import { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface NbPageHeaderProps {
  slug: string;
  title: ReactNode;
  subtitle?: ReactNode;
  fill?: 'lost' | 'found' | 'solved' | 'urgent' | 'paper';
  className?: string;
  tone?: 'banner' | 'plain';
}

const FILL_CLASS: Record<NonNullable<NbPageHeaderProps['fill']>, string> = {
  lost: 'fill-lost',
  found: 'fill-found',
  solved: 'fill-solved',
  urgent: 'fill-urgent',
  paper: 'fill-paper',
};

export const NbPageHeader: FC<NbPageHeaderProps> = ({
  slug,
  title,
  subtitle,
  fill = 'paper',
  className,
  tone = 'banner',
}) => {
  if (tone === 'plain') {
    return (
      <header className={cn('px-4 pb-2 pt-1', className)}>
        <div
          className="text-[11px] font-bold uppercase tracking-[0.08em] opacity-60"
          style={{ fontFamily: '"JetBrains Mono", monospace' }}
        >
          {slug}
        </div>
        <h1 className="font-display mt-1 text-[36px] leading-[0.9]">{title}</h1>
        {subtitle && <div className="mt-2 text-[13px] font-medium">{subtitle}</div>}
      </header>
    );
  }

  return (
    <header
      className={cn(
        FILL_CLASS[fill],
        'relative pb-5 pt-3',
        'ml-[calc(50%-50vw)] w-screen px-[calc(50vw-50%+1rem)]',
        className,
      )}
      style={{ borderBottom: '3px solid var(--nb-ink)' }}
    >
      <div
        className="text-[11px] font-bold uppercase tracking-[0.08em] opacity-70"
        style={{ fontFamily: '"JetBrains Mono", monospace' }}
      >
        {slug}
      </div>
      <h1 className="font-display mt-1 text-[36px] leading-[0.9]">{title}</h1>
      {subtitle && <div className="mt-2 text-[13px] font-semibold">{subtitle}</div>}
    </header>
  );
};
